<template>
    <div id="echartView2" ref="echartView" style="width: 23vw;height: 300px;margin-right: 30px;"></div>
</template>

<script>
    var echarts = require('echarts');
    export default {
        name: "SourceChart",
        props: {
            xAxisData: Array,
            yAxisData: Array,
            title:String
        },
        mounted() {
            const myChart = echarts.init(this.$refs.echartView);

            // 指定图表的配置项和数据
            const option = {
                // title : {
				// 	text: [...this.title[0].replace(',','')],
				// 	subtext: '',
				// 	x:'left'
				// },
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [...this.xAxisData],
                        axisTick: {
                            alignWithLabel: false
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                // series: this.series
                series:
                    [
                        {
                            name: 'cnt',
                            type: 'bar',
                            barWidth: '60%',
                            data: [...this.yAxisData]
                        }
                    ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    }
</script>

<style scoped>

</style>